<template>
<div class="m-content">
        <MenuViews></MenuViews>

        <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{ labels.view_ingredients | capitalize }} {{ hits.length ? `(${ hits.length } ${labels.products})` : '' }}</h3>
        </div>
      </div>

      <div class="m-portlet__head-tools">
        <ul class="m-portlet__nav">
          <li class="m-portlet__nav-item">
              <button
                @click="exportExcel()"
                type="button"
                class="btn btn-elevate btn-icon-sm btn-pill"
              >
                <i class="la la-download"></i>
                {{ labels.export | capitalize }}
              </button>
          </li>
          <li class="m-portlet__nav-item">
              <button
                tag="button"
                @click="$router.go(-1)"
                class="btn btn-elevate btn-icon-sm btn-pill">{{ labels.return | capitalize }}</button>
            </li>
            <!-- <li class="m-portlet__nav-item">
              <router-link
                        to="/dashboard/manage-products"
                        tag="button" class="btn btn-outline-success btn-elevate btn-pill" >
                        {{ labels.return | capitalize }}
                    </router-link>
            </li> -->

        </ul>
      </div>
    </div>
    <div class="m-portlet__body">
        <TableWithFilter
          :rawData="rawData"
          :fields="fields"
          :viewlabels="labels.exportIngredientView"
          :facetFilters="searchParameters ? searchParameters.facetFilters : []"
        ></TableWithFilter>
    </div>
  </div>

    </div>

</template>

<script>
import { mapState } from 'vuex';
import * as algoliasearch from 'algoliasearch';
import TableWithFilter from '../../Table/TableWithFilter.vue';
import MenuViews from '../MenuViews.vue';
import exportIngredientView from '../../../assets/js/exportIngredientView';

const client = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY,
);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);

export default {
  name: 'IngredientsTable',
  components: {
    TableWithFilter,
    MenuViews,
  },
  watch: {
    $route(value) {
      // Watch when param changes
      this.activeTable = value.name || value.params.name;
    },
  },
  data() {
    return {
      activeTable: null,
      hits: [],
      rawData: null,
      ingredientsStats: {},
      query: '',
      searchParameters: null,
      browseObject: null,
      fields: [
        {
          id: 'ingredients',
          orderable: true,
          searchType: 'text',
          filterName: 'ingredients',
          orderData: [0],
          facetFilters: 'ingredientsMix.name',
          width: '200px',
        },
        {
          id: 'numberInProduct',
          orderable: true,
          searchType: false,
          filterName: 'segmentationParents',
          orderData: [1, 0],
          width: '100px',
        },
        {
          id: 'percentageShow',
          orderable: true,
          searchType: false,
          filterName: 'percentageShow',
          orderData: [2, 0],
          width: '100px',
        },
        {
          id: 'roles',
          orderable: false,
          searchType: 'text',
          filterName: 'roles',
          facetFilters: 'rolesMix.name',
        },
        {
          id: 'claimed',
          orderable: true,
          searchType: false,
          filterName: 'claimed',
          orderData: [4, 0],
          width: '100px',
        },
        {
          id: 'relatedIncis',
          orderable: false,
          searchType: 'text',
          filterName: 'relatedIncis',
          facetFilters: 'ingredientsV2.related_inci',
        },
        {
          id: 'numberInPatent',
          orderable: true,
          searchType: false,
          filterName: 'numberInPatent',
          orderData: [6, 0],
          width: '100px',
        },
        {
          id: 'themes',
          orderable: false,
          searchType: 'text',
          filterName: 'themes',
          facetFilters: 'themes',
        },
        {
          id: 'parentSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'parentSegmentations',
          facetFilters: 'parentSegmentation',
        },
        {
          id: 'subSegmentations',
          orderable: false,
          searchType: 'text',
          filterName: 'subSegmentations',
          facetFilters: 'subSegmentation',
          width: '700px',
        },
      ],
      filters: {
        ingredients: [],
        numberInProduct: '',
        percentageShow: '',
        roles: '',
        claimed: '',
        relatedIncis: '',
        numberInPatent: '',
        themes: '',
        parentSegmentations: '',
        subSegmentations: '',
      },
    };
  },
  mixins: [exportIngredientView],
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      selectedProductIds: (store) => store.products.selectedProductIds,
      allSelected: (store) => store.products.allSelected,
      lastSearch: (store) => store.products.lastSearch,
      previewURL: (store) => store.products.previewURL,
    }),
  },
  methods: {
    run() {
      this.hits = [];
      this.ingredientsStats = [];
      this.rawData = null;
      this.browse();
    },
    initBrowseObject() {
      let myfacetFilters = [];
      if (this.searchParameters.facetFilters) {
        myfacetFilters = [...this.searchParameters.facetFilters];
      }
      myfacetFilters.push(['hasClaims:true', 'hasClaims:false']);
      // const restrictSearchableAttributes = JSON.parse(
      //   this.searchParameters.restrictSearchableAttributes,
      // );
      const restrictSearchableAttributes = '';

      this.browseObject = {
        facetFilters: myfacetFilters,
        restrictSearchableAttributes,
      };
    },
    browse() {
      const browser = productIndex.browseAll(
        this.query,
        this.browseObject,
      );
      const my = this;
      browser.on('result', (content) => {
        my.hits = my.hits.concat(content.hits);
      });

      browser.on('end', () => {
        console.log('We got %d hits', my.hits.length);
        this.startStats();
        this.rawData = this.transformObjectToArrayV2(this.ingredientsStats);
      });

      browser.on('error', (err) => {
        throw err;
      });
    },
    startStats() {
      const my = this;

      this.hits.forEach((hit) => {
        const ingredientsInThisHit = [];
        const currentIngredientInProduct = [];

        // ingredients inside product
        if (hit.ingredientsV2) {
          hit.ingredientsV2.forEach((ingredient) => {
            this.addIngredientIfNotYet(ingredient.name);

            // check if we didn't count this ingredient already for this product
            if (currentIngredientInProduct.indexOf(ingredient.name) === -1) {
              currentIngredientInProduct.push(ingredient.name);
              if (ingredient.claimed) {
                my.ingredientsStats[ingredient.name].claimed += 1;
              }
            }

            this.generalStatPerHit(ingredientsInThisHit, ingredient.name, hit);
            this.updatePercentage(ingredient.name);

            this.ingredientsStats[ingredient.name].roles = this.addIngredientStats(
              this.ingredientsStats[ingredient.name].roles,
              ingredient.roles.map((role) => role.name),
            );
            this.setIngredientRelatedIncisStat(ingredient.name, ingredient.related_inci);
          });
        }

        // ingredient inside patent
        if (hit.patentsV2) {
          const currentIngredientInPatent = [];
          hit.patentsV2.forEach((patent) => {
            patent.ingredients.forEach((ingredient) => {
              this.addIngredientIfNotYet(ingredient.name);
              // check if we didn't count this ingredient already for this product (in other patent)
              if (currentIngredientInPatent.indexOf(ingredient.name) === -1) {
                currentIngredientInPatent.push(ingredient.name);
                my.ingredientsStats[ingredient.name].numberInPatent += 1;
              }
              this.generalStatPerHit(ingredientsInThisHit, ingredient.name, hit);
              this.updatePercentage(ingredient.name);
              this.setIngredientRelatedIncisStat(ingredient.name, ingredient.related_inci);
            });
          });
        }
      });
    },
    updatePercentage(ingredientName) {
      // actualise the percentage
      this.ingredientsStats[ingredientName].percentageShow = this.ingredientsStats[ingredientName].numberInProduct
        ? this.ingredientsStats[ingredientName].numberInProduct
                / this.hits.length
        : 0;
    },
    setIngredientRelatedIncisStat(ingredientName, relatedInci) {
      if (relatedInci) {
        if (!Object.prototype.hasOwnProperty.call(this.ingredientsStats[ingredientName].relatedIncis, relatedInci)) {
          this.ingredientsStats[ingredientName].relatedIncis[relatedInci] = 0;
        }
        this.ingredientsStats[ingredientName].relatedIncis[relatedInci] += 1;
      }
    },
    addIngredientIfNotYet(ingredientName) {
      if (!Object.prototype.hasOwnProperty.call(this.ingredientsStats, ingredientName)) {
        this.ingredientsStats[ingredientName] = {
          name: ingredientName,
          numberInProduct: 0,
          numberInPatent: 0,
          percentageShow: 0,
          roles: [],
          relatedIncis: [],
          themes: [],
          parentSegmentations: [],
          subSegmentations: [],
          claimed: 0,
        };
      }
    },
    addIngredientStats(elemStats, elems) {
      const stats = elemStats;
      if (elems) {
        const temp = [];
        elems.forEach((elem) => {
          if (temp.indexOf(elem) === -1) {
            temp.push(elem);
            if (
              !Object.prototype.hasOwnProperty.call(stats, elem)
            ) {
              stats[elem] = 0;
            }
            stats[elem] += 1;
          }
        });
      }

      return stats;
    },
    generalStatPerHit(ingredientsInThisHit, ingredientName, hit) {
      if (ingredientsInThisHit.indexOf(ingredientName) === -1) {
        ingredientsInThisHit.push(ingredientName);
        this.ingredientsStats[ingredientName].numberInProduct += 1;
        this.ingredientsStats[ingredientName].themes = this.addIngredientStats(
          this.ingredientsStats[ingredientName].themes,
          hit.themes,
        );
        this.ingredientsStats[ingredientName].parentSegmentations = this.addIngredientStats(
          this.ingredientsStats[ingredientName].parentSegmentations,
          hit.parentSegmentation,
        );
        this.ingredientsStats[ingredientName].subSegmentations = this.addIngredientStats(
          this.ingredientsStats[ingredientName].subSegmentations,
          hit.subSegmentation,
        );
      }
    },
    exportExcel() {
      this.exportIngredientView(this.ingredientsStats, this.hits.length);
    },
    createParams(params) {
      try {
        const searchParameters = {
          attributesToRetrieve: ['productId'],
        };
        params.forEach((param) => {
          const splitParam = param.split('=');
          const key = decodeURIComponent(splitParam[0]);
          const value = decodeURIComponent(splitParam[1]);

          if (key === 'hitsPerPage') {
            searchParameters[key] = 1000;
          } else if (key === 'page') {
            searchParameters[key] = 0;
          } else {
            searchParameters[key] = value;
          }
        });

        searchParameters.facetFilters = (searchParameters.facetFilters) ? JSON.parse(searchParameters.facetFilters) : [];

        return searchParameters;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    setSearchParameter() {
      if (this.previewURL.length) {
        // Get the last result object
        const lastResult = this.previewURL[0];
        if (lastResult) {
          this.query = lastResult.query;

          const queryArray = lastResult.params.split('&');
          this.searchParameters = this.createParams(queryArray, 0);
        }
      }
    },
    goToIngredientsView() {
      this.$router.push({ name: 'IngredientsTable' });
    },
    goToRolesView() {
      this.$router.push({ name: 'RolesTable' });
    },
    goToRelatedIncisView() {
      this.$router.push({ name: 'RelatedIncisTable' });
    },
  },
  mounted() {
    this.setSearchParameter();
    this.initBrowseObject();
    this.run();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/Ingredients/IngredientsTable.vue